module.exports = __webpack_public_path__ + "assets/img/cloud.c03ab3ac.png";